import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { FreePublisherInfoDialogComponent } from 'src/app/free-publisher-info-dialog/free-publisher-info-dialog.component';
import { WidgetEditFiltersEditDialogComponent } from '../widget-edit-filters-edit-dialog/widget-edit-filters-edit-dialog.component';
import { deepCopy } from 'na-lib';
import { ChangeDetectorRef, NgZone } from '@angular/core';
import { SettingsService } from 'src/app/service/settings.service';
import { TranslateService } from '@ngx-translate/core';

interface filterNode {
  field?: string;
  operator?:string;
  value?:boolean;
  and?: filterNode[];
  or?:filterNode[]
  type?:string
}

@Component({
    selector: '[app-widget-edit-filters]',
    templateUrl: './widget-edit-filters.component.html',
    styleUrls: ['./widget-edit-filters.component.css'],
    standalone: false
})

export class WidgetEditFiltersComponent {
  contextLicenseFree = false
  filtersData:any = {}
  filterTypes= [
    {
      type:'=',
      translate:'pass.widgets.filter.comparisson',
      tooltipKey: 'pass.widgets.filter.comparissonTooltip',
      active:true,
      name:'comparisson'
    },
    {
      type:'and',
      translate:'pass.widgets.filter.and',
      tooltipKey: 'pass.widgets.filter.andTooltip',
      active:true,
      name:'and'
    },
    {
      type:'or',
      translate:'pass.widgets.filter.or',
      tooltipKey: 'pass.widgets.filter.orTooltip',
      active:true,
      name:'or'
    }
  ]

  addDisabed = false
  filterOperatorTypes = [
    {
      type:'==',
      translate: "pass.widgets.filter.operators.equal",
      name:'equal'
    },
    {
      type:'!=',
      translate: "pass.widgets.filter.operators.not_equal",
      name:"not_equal"
    },
    {
      type:'<',
      translate: "pass.widgets.filter.operators.less_than",
      name:"less_than"
    },
    {
      type:'>',
      translate: "pass.widgets.filter.operators.more_than",
      name:"more_than"
    },
    {
      type:'<=',
      translate: "pass.widgets.filter.operators.at_least",
      name:"at_least"
    },
    {
      type:'>=',
      translate: "pass.widgets.filter.operators.at_most",
      name:"at_most"
    }
  ]

  filterOperatorTypesObject = {
    '==':{
      type:'==',
      translate: "pass.widgets.filter.operator.equal"
    },
    '!=':{
      type:'!=',
      translate: "pass.widgets.filter.operator.not_equal"
    },
    '<':{
      type:'<',
      translate: "pass.widgets.filter.operator.less_than"
    },
    '>':{
      type:'>',
      translate: "pass.widgets.filter.operator.more_than"
    },
    '<=':{
      type:'<=',
      translate: "pass.widgets.filter.operator.at_least"
    },
    '>=':{
      type:'>=',
      translate: "pass.widgets.filter.operator.at_most"
    }
  }

  filterKeys:string[]
  filterForm!:FormGroup
  @Input('app-widget-edit-filters') data:any;
  allproperties:filterNode[]
  TREE_DATA:filterNode[]

  treeControl = new NestedTreeControl<filterNode>(
    (node) => node?.and ?? node?.or ?? []
  );

  hasGroup = (_: number, node: filterNode) =>
  Array.isArray(node.and) || Array.isArray(node.or);

  isComparison = (_: number, node: filterNode) =>
  !!node.field && node.operator != null && node.value !== undefined;

  dataSource = new MatTreeNestedDataSource<filterNode>();
  disableAddFilters = false
  @Output() returnChanges = new EventEmitter<{newFilters: any, widget: any, widgetId:string}>()

  translationMode = false

  constructor(public dialogRef: MatDialogRef<WidgetEditFiltersComponent>,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    private fb: FormBuilder,
    private settingsService: SettingsService,
    private translate:TranslateService){}

  ngOnInit(): void {
    this.settingsService.contextLicenseFreePublisher$.subscribe( value => this.contextLicenseFree = value)
    this.translationMode = this.data?.widgetData ? this.data.widgetData?.translateMode : false
    this.filterForm = this.fb.group({ filters: [] });

    if (this.data.form?.filter) {
      this.filtersData = deepCopy(this.data.form.filter ?? {});
      this.setDataSourceRoot(this.filtersData);
      this.disableAddFilters = Object.keys(this.filtersData).length > 0;
    } else {
      this.setDataSourceRoot(undefined);
    }

    this.filterForm.get('filters')!.valueChanges.subscribe(value => {
      this.filtersData = value ?? {};
      this.setDataSourceRoot(Object.keys(this.filtersData).length ? this.filtersData : undefined);
      this.disableAddFilters = !!Object.keys(this.filtersData).length;
      this.refreshTree();
      this.treeControl.expandAll();
      if(!this.translationMode){
        this.returnChanges.emit({
          newFilters: Object.keys(this.filtersData).length ? this.filtersData : undefined,
          widget: this.data.form ,
          widgetId: this.data.form?.id
        });
      }
      
    });
  }

  ngOnDestroy(){
    //console.log('--destroy widget-edit-filters--')
  }

  get checkLicenseFree(): boolean{
    return this.contextLicenseFree ? true : false
  }

  addFilterType(filter) {
    switch (filter.type) {
      case '=': {
        const dialogRef = this.dialog.open(WidgetEditFiltersEditDialogComponent, { data: { type: 'add' }});
        dialogRef.afterClosed().subscribe(result => {
          if (!result?.[0]) return;
          this.filtersData = { field: result[1].field, operator: result[1].operator, value: result[1].value };
          this.filterForm.patchValue({ filters: this.filtersData }, { emitEvent: true });
          this.setDataSourceRoot(this.filtersData);
          this.refreshTree();
        });
        break;
      }
      case 'and': {
        this.filtersData = { and: [] };
        this.filterForm.patchValue({ filters: this.filtersData }, { emitEvent: true });
        this.setDataSourceRoot(this.filtersData);
        this.refreshTree();
        break;
      }
      case 'or': {
        this.filtersData = { or: [] };
        this.filterForm.patchValue({ filters: this.filtersData }, { emitEvent: true });
        this.setDataSourceRoot(this.filtersData);
        this.refreshTree();
        break;
      }
    }
  }

  toggleGroupKind(node: filterNode, to: 'and' | 'or') {
    if (to === 'and' && node.or) {
      node.and = [...node.or];
      delete node.or;
    } else if (to === 'or' && node.and) {
      node.or = [...node.and];
      delete node.and;
    }
    this.filterForm.patchValue({ filters: this.dataSource.data[0] }, { emitEvent: true });
    this.refreshTree();
  }

  private findParentAndIndex(root: filterNode, target: filterNode)
    : { parent: filterNode | null, key: 'and' | 'or' | null, index: number }
  {
    const stack: filterNode[] = [root];
    while (stack.length) {
      const cur = stack.pop()!;
      const key: 'and' | 'or' | null = cur.and ? 'and' : (cur.or ? 'or' : null);
      if (key && Array.isArray(cur[key])) {
        const idx = cur[key]!.indexOf(target);
        if (idx > -1) return { parent: cur, key, index: idx };
        for (const child of cur[key]!) stack.push(child);
      }
    }
    return { parent: null, key: null, index: -1 };
  }

    openFreePublisherCTA(){
    let dialogRef= this.dialog.open(FreePublisherInfoDialogComponent, {
      panelClass: 'freepublisher-dialog-container',
      data:{
        closeBtnLabel:this.translate.instant('Close')
      }
    });
    dialogRef.afterClosed().subscribe(result => {})
  }


  deleteNode(node: filterNode) {
    if (!this.dataSource.data?.length) return;

    const root = this.dataSource.data[0];
    // deleting root comparison/group
    if (node === root) {
      this.deleteAllFilter();
      return;
    }

    const { parent, key, index } = this.findParentAndIndex(root, node);
    if (!parent || !key || index < 0) return;

    // immutable remove
    parent[key] = parent[key]!.slice(0, index).concat(parent[key]!.slice(index + 1));

    // prune empty groups if you want
    if (parent[key]!.length === 0) delete parent[key];

    this.filterForm.patchValue({ filters: this.dataSource.data[0] }, { emitEvent: true });
    this.refreshTree();
  }

  editFilterType(node: filterNode, type: 'and' | 'or' | '=') {

    const entries = Object.entries(node)

    let newNode = node ?? {}
    switch(type){
      case 'or' :{
        node['or'] = deepCopy(entries[0][1])
        delete node['and']
        this.filterForm.patchValue({filters: this.dataSource.data[0]})
        break;
      }
      case 'and' :{
        node['and'] = deepCopy(entries[0][1])
        delete node['or']
        this.filterForm.patchValue({filters: this.dataSource.data[0]})
        break;
      }

      case '=':{
        this.addDisabed = true
        let dialogRef= this.dialog.open(WidgetEditFiltersEditDialogComponent, {
          data: { 
            type:"edit",
            values: node
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          if(result[0]){
            node.field = result[1].field
            node.operator = result[1].operator
            node.value = result[1].value
            this.filterForm.patchValue({filters: this.filtersData})
          }
        });
        break;
      }
    }

  }

  getOperatorText(type){
    return this.filterOperatorTypes.find( op => op.type == type)?.translate
  }

  hasChild = (_: number, node: filterNode) =>
  (node.and?.length ?? 0) > 0 || (node.or?.length ?? 0) > 0;
  
  isArrayType = ( _: number,node: filterNode) => node.and || node.or;
  isComparisson = (_: number, node: filterNode) => node.field && node.value && node.operator;
  isObject(val): boolean { return typeof val === 'object';}
  getKeysObject(object){return Object.keys(object)}
  
  addFilterTypeToNode(type, node: filterNode) { 
    const groupKey = node.and ? 'and' : node.or ? 'or' : null;
    if (!groupKey) return;

    switch (type.type) {
      case '=': {
        const dialogRef = this.dialog.open(WidgetEditFiltersEditDialogComponent, { data: { type: 'add' }});
        dialogRef.afterClosed().subscribe(result => {
          if (!result?.[0]) return;
          const newComp = { field: result[1].field, operator: result[1].operator, value: result[1].value };
          const updated = this.replaceArray(node[groupKey]!, draft => [...draft, newComp]);
          // IMPORTANT: reassign to a NEW array reference
          node[groupKey] = updated;
          this.filterForm.patchValue({ filters: this.dataSource.data[0] }, { emitEvent: true });
          this.refreshTree();
        });
        break;
      }
      case 'and': {
        node[groupKey] = [...(node[groupKey] ?? []), { and: [] }];
        this.filterForm.patchValue({ filters: this.dataSource.data[0] }, { emitEvent: true });
        this.refreshTree();
        break;
      }
      case 'or': {
        node[groupKey] = [...(node[groupKey] ?? []), { or: [] }];
        this.filterForm.patchValue({ filters: this.dataSource.data[0] }, { emitEvent: true });
        this.refreshTree();
        break;
      }
    }
  }
  
  getDisableNodeChilds(node){
    let child = false
    ///-------this is to limit childs of each filter to 2

    // if(node?.and?.length>=2)
    // child = true

    // if(node?.or?.length>=2)
    // child = true

    return child
  }

  deleteAllFilter(){
    this.filtersData = {}
    this.filterKeys = []
    this.dataSource.data = []
    this.refreshTree()
    this.filterForm.patchValue({filters:{}})
    this.disableAddFilters = false
  }

  clearFilter(){
    this.filtersData = {}
    this.filterKeys = []
    this.filterForm.patchValue({filters:{}})
  }

  // HELPERS:

  private setDataSourceRoot(root: filterNode | undefined) {
    this.dataSource.data = root ? [root] : [];
    // optional: keep dataNodes in sync to avoid odd expansion glitches
    this.treeControl.dataNodes = this.dataSource.data as any;
  }

  private replaceArray<T>(arr: T[], updater: (draft: T[]) => T[]): T[] {
    const copy = [...arr];
    return updater(copy);
  }

  private refreshTree() {
    const root = this.dataSource.data?.[0] ?? this.filtersData ?? undefined;
    const clone = root ? deepCopy(root) : undefined;

    // Rebuild data with NEW root object identity
    this.dataSource.data = clone ? [clone] : [];
    this.treeControl.dataNodes = this.dataSource.data as any;

    // Nudge the dialog view immediately
    this.zone.run(() => this.cdr.detectChanges());
    this.treeControl.expandAll(); 
  }
   
}
